module.exports = "/images/signin.svg?3f0b28331754976035c39adfeb9df525";